<template>
  <div id="wrapper" class="page">
    <div id="content-wrapper">
      <div class="container-fluid">
        <button class="btn btn-success mb-2 mr-2" @click.prevent="openReportModal" >
          <i class="far fa-file-excel"></i> Report
        </button>
      </div>
    </div>
    <!-- REPORT MODAL -->
    <b-modal
        v-model="reportModalShow"
        header-bg-variant="primary"
        header-text-variant="light"
        hide-footer
        @hidden="closeReportModal"
        title="CHOOSE A REPORT"
        text-center
        no-close-on-backdrop
        no-close-on-esc
      >
        <b-form autocomplete="false" @submit.prevent="exportExcel">
          <b-row>
            <b-col cols="6">
              <b-form-select v-model="year_selected" class="mb-2" :options="optionsYear" value-field="value" text-field="text" required>
                  <template #first>
                    <b-form-select-option value="0">Year</b-form-select-option>
                  </template>
                </b-form-select>
            </b-col>
            <b-col cols="6">
              <b-form-select v-model="month_selected" class="mb-2" :options="optionsMonth" value-field="value" text-field="text" required>
                  <template #first>
                    <b-form-select-option value="0">Month</b-form-select-option>
                  </template>
                </b-form-select>
            </b-col>
          </b-row>
          <b-row v-if="type_selected==0">
            <b-col>
              <b-form-group>
              <template v-slot:label>
                Employee:
              </template>
              <multiselect
                  v-model="employee_selected"
                  placeholder
                  :options="employees"
                  track-by="id"
                  label="mahovaten"
                  selectedLabel="Selecting..."
                  select-label="Enter to choose"
                  deselectLabel="Enter to remove"
                  :searchable="true">
              </multiselect>
            </b-form-group>
            </b-col>
          </b-row>
          <b-row>
            <b-col>
              <b-form-select v-model="type_selected" class="mb-2" :options="optionsType" text-field="text" valye-field="value" required/>
            </b-col>
          </b-row>
          <button class="btn btn-success mr-2" style="float:right;" type="submit">
            <i class="far fa-file-excel"></i> Export
          </button>
        </b-form>
      </b-modal>
      <!-- END OF REPORT MODAL -->
  </div>
</template>

<script>
import axios from "axios";
import Multiselect from "vue-multiselect";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "QtakeReport",
  components: {
    Multiselect,
  },
  data() {
    return {
      optionsMonth: [ {value: 1, text: "Tháng 1"},
                      {value: 2, text: "Tháng 2"},
                      {value: 3, text: "Tháng 3"},
                      {value: 4, text: "Tháng 4"},
                      {value: 5, text: "Tháng 5"},
                      {value: 6, text: "Tháng 6"},
                      {value: 7, text: "Tháng 7"},
                      {value: 8, text: "Tháng 8"},
                      {value: 9, text: "Tháng 9"},
                      {value: 10, text: "Tháng 10"},
                      {value: 11, text: "Tháng 11"},
                      {value: 12, text: "Tháng 12"},
                      {value: 13, text: "Quý I"},
                      {value: 14, text: "Quý II"},
                      {value: 15, text: "Quý III"},
                      {value: 16, text: "Quý IV"},
      ],
      // optionsType: [{value: null, text: "--Please select a report type--"},{value: 0, text: "Qtake Bonus theo nhân viên"}, {value: 1, text: "Qtake Bonus tổng hợp"}, {value: 2, text: "Qtake Project"}],
      optionsType: [{value: null, text: "--Please select a report type--"}, {value: 1, text: "Report 1 - Qtake Project"}, {value: 2, text: "Report 2 - Qtake Bonus"}, {value: 3, text: "Report 3 - Qtake Bonus by Employee"}],
      reportModalShow: false,
      month_selected: null,
      year_selected: null,
      type_selected: null,
      employee_selected: null,
      employees: [],
    }
  },
  beforeRouteEnter(to, from, next) {
    axios
      .all([
        axios.get("/api/employee/getall"),
      ])
      .then(
        axios.spread((employee) => {
            next((vm) => vm.initData(employee.data));
          }
        )
      );
  },
  computed: {
    optionsYear() {
      var result = [];
      var this_year = new Date().getFullYear();
      for (var i = this_year; i >= 2020; i--) {result.push({value: i, text: i});}
      return result;
    },
  },
  methods: {
    initData(employees) {
      this.month_selected = new Date().getMonth() + 1;
      this.year_selected = new Date().getFullYear();
      this.employees = employees;
      let null_value = {id: null, mahovaten: "Tất cả"}
      this.employees.unshift(null_value);
      this.employee_selected = null_value;
      this.reportModalShow = true;
    },
    openReportModal() {
      this.month_selected = new Date().getMonth() + 1;
      this.year_selected = new Date().getFullYear();
      this.reportModalShow = true;
    },
    closeReportModal() {
      this.reportModalShow = false;
    },
    exportExcel() {
      let query = Object.assign({}, this.$route.query);
      query.type = this.type_selected;
      if (this.employee_selected != null) query.employee_id = this.employee_selected.id;
      query.year = this.year_selected;
      query.month = this.month_selected;

      axios({
        method: "get",
        url: `/api/qtakereport/report`,
        params: query,
        responseType: "blob", // important
        })
        .then((res) => {
          this.$download_excel_file(res);
        })
        .catch((err) => {this.$toast.error(err.response.data, "Error", {timeout: 2000});});
    }
  }
}
</script>